<script lang="tsx">
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import { ViewModeType } from '@xhs/yam-beer/cmp/constants'
  import {
    dayjs,
    getYearMatrix,
    getMonthMatrix,
    getMonthShortLocale,
  } from '@xhs/yam-beer/utils/dayjs'
  import type { Dayjs } from 'dayjs'
  import { includes, range } from 'lodash'
  import DayView, { CalanderDayViewProps } from './DayView.vue'

  function isMonthDisabled(year: number, month: number, disableDay: (s: Dayjs) => boolean) {
    const daysInMonth = dayjs().year(year).month(month - 1).daysInMonth()
    const monthDayObjs = range(0, daysInMonth).map(d => dayjs().year(year).month(month - 1).date(d))
    return disableDay && monthDayObjs.every(disableDay)
  }

  function isYearDisabled(year: number, disableDay: (s: Dayjs) => boolean) {
    return disableDay && range(1, 13).every(month => isMonthDisabled(year, month, disableDay))
  }

type Value = string[]
type MatrixViewProps = {
  matrix: Value[]
  activeValue: string[]
  nowValue: string
  handleClick: (s: string|number) => void
  disabldItemFn: (s: string|number) => boolean
}
  const MatrixView = (
    {
      matrix, activeValue, nowValue, handleClick, disabldItemFn,
      }: MatrixViewProps,
  ) => (
  <NewBsBox>
    {matrix.map((row, i) => (
      <NewBsBox bs={{ 'cmp.calendar': 'row' }} key={i}>
        {row.map((item, j) => (
          <NewBsBox
            bs={{
              'cmp.calendar': 'matrixCell',
            }}
            data-selected={includes(activeValue, item) ? 'true' : null}
            data-today={nowValue === item ? 'true' : null}
            data-disabled={(disabldItemFn?.(item.replace(/\D+/g, ''))) || null}
            key={i + j}
            {...{
              onClick: () => handleClick(item.replace(/\D+/g, '')),
            }}
          >
            {item}
          </NewBsBox>
        ))}
      </NewBsBox>
    ))}
  </NewBsBox>
)
  MatrixView.Props = {
    matrix: {},
    activeValue: {},
    nowValue: {},
    onClick: {},
    disabldItemFn: {},
  }

type RenderViewProps = {
  viewMode: ViewModeType
  current: Dayjs
  dayProps: CalanderDayViewProps
  setBase: (d: Dayjs) => void
  setViewMode: (mode: ViewModeType, nextBase: Dayjs) => void
  selected: Dayjs[]
  disableDay: (s: Dayjs) => boolean
}
  const RenderView = ({
    viewMode, current, dayProps, selected, disableDay, setViewMode, setBase,
    }: RenderViewProps) => {
    const now = dayjs()
    const currentYear = dayjs(current).year()
    if (viewMode === 'y') {
      const currentYearSelected = (selected || []).map((i: Dayjs) => {
        const itemYear = dayjs(i).year()
        return `${itemYear}`
      })
      return (
      <MatrixView
        matrix={getYearMatrix(currentYear)}
        activeValue={currentYearSelected}
        nowValue={`${now.year()}`}
        handleClick={(y: number) => {
          if (isYearDisabled(y, disableDay)) return
          setBase(current.year(y))
          setViewMode('m', current.year(y))
        }}
        disabldItemFn={(y: number) => isYearDisabled(y, disableDay)}
      />
    )
    }
    if (viewMode === 'm') {
      const currentMonthSelected = (selected || []).map((i: Dayjs) => {
        const itemYear = dayjs(i).year()
        const itemMonth = getMonthShortLocale(dayjs(i).month())
        return currentYear === itemYear ? itemMonth : -1
      })
      return (
      <MatrixView
        matrix={getMonthMatrix()}
        activeValue={currentMonthSelected}
        nowValue={getMonthShortLocale(now.month())}
        handleClick={(m: number) => {
          if (isMonthDisabled(currentYear, m, disableDay)) return
          setBase(current.month(m - 1))
          setViewMode('d', current.month(m - 1))
        }}
        disabldItemFn={(m: number) => isMonthDisabled(currentYear, m, disableDay)}
      />
    )
    }
    if (viewMode === 'd') {
      return <DayView {...dayProps} />
    }
    return null
  }
  RenderView.Props = {
    viewMode: {},
    current: {},
    dayProps: {},
    setBase: {},

    setViewMode: {},
    selected: {},
    disableDay: {},
  }

type CalendarBodyProps = {
  viewMode: ViewModeType
  current: Dayjs
  selected: Dayjs[]
  disableDay: (s: Dayjs) => boolean

  base: Dayjs
  setBase: (d: Dayjs) => void
  startDay: Dayjs
  endDay: Dayjs
  handleMouseOver?: (d: Dayjs) => void
  onClickDay?: (d: Dayjs) => void
  setViewMode: (mode: ViewModeType, nextBase: Dayjs) => void

  disableMonth?: any
  disableYear?: any
}

  const CalendarBody = (props: CalendarBodyProps) : JSX.Element => {
    const {
      viewMode,
      current,
      selected,
      disableDay,
      setBase,
      setViewMode,
    } = props
    return (
    <NewBsBox data-calendar="body" bs={{ 'cmp.calendar': 'body' }}>
      <RenderView
        viewMode={viewMode}
        current={current}
        setBase={setBase}
        setViewMode={setViewMode}
        dayProps={props}
        selected={selected}
        disableDay={disableDay}
      />
    </NewBsBox>
  )
  }
  CalendarBody.Props = {
    viewMode: {},
    current: {},
    selected: {},
    disableDay: {},

    base: {},
    setBase: {},
    startDay: {},
    endDay: {},
    handleMouseOver: {},
    onClickDay: {},
    setViewMode: {},

    disableMonth: {},
    disableYear: {},
  }
  export default CalendarBody
</script>
